import React from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';

const DepositSearch = ({ onChange, otherDeposit, totalCard, totalCash, totalDeposit, totalPay, totalSlickPos }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="DepositSearch" className="deposit-search-container">
      <div data-bem="DepositSearch__search" className="search">
        <span>{t('balanceSheet.tableHeaders.outstandingDeposits')}</span>
        <input data-bem="DepositSearch__search-client" name="text" type="text" onChange={onChange} placeholder={t('balanceSheet.tableHeaders.outstandingDepPlaceholder')} />
      </div>
      <div data-bem="DepositSearch__cash" className="total">
        <strong>
          <div className="break" />
          {t('balanceSheet.tableHeaders.cash')}:
        </strong>
        <span>
          <CurrencySign value={totalCash} />
        </span>
      </div>
      <div data-bem="DepositSearch__card" className="total">
        <strong>
          {t('balanceSheet.tableHeaders.cardInStore')}
          <div className="break" />
          {t('balanceSheet.tableHeaders.nonSlick')}:
        </strong>
        <span>
          <CurrencySign value={totalCard} />
        </span>
      </div>

      <div data-bem="DepositSearch__slick-pay" className="total">
        <strong>
          {t('balanceSheet.tableHeaders.cardInStore')}
          <div className="break" />
          {t('balanceSheet.tableHeaders.slickPay')}:
        </strong>
        <span>
          <CurrencySign value={totalSlickPos} />
        </span>
      </div>

      <div className="total">
        <strong>
          {t('balanceSheet.tableHeaders.cardOnline')}
          <div className="break" />
          {t('balanceSheet.tableHeaders.slickPay')}:
        </strong>
        <span>
          <CurrencySign value={totalPay} />
        </span>
      </div>
      <div className="total">
        <strong>
          {t('common.other')}: <div className="break" />
        </strong>
        <span>
          <CurrencySign />
          {otherDeposit}
        </span>
      </div>
      <div className="total">
        <strong>
          {t('common.total').toUpperCase()}:
          <div className="break" />
        </strong>
        <span>
          <CurrencySign value={totalDeposit} />
        </span>
      </div>
      <div className="total" />
    </div>
  );
};

export default DepositSearch;
